export default __webpack_public_path__ + "static/media/columnoption_light.e88b1e03.svg";